import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Dashboard from './Dashboard';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorHandler from './ErrorHandler';

ReactDOM.render(
    <Router>
      <ErrorHandler>
        <Dashboard />
      </ErrorHandler>
    </Router>,
  document.getElementById('root')
);
